import qs from 'qs';
import client from './rest/SignedUrlClient';

const getSignedUrl = (type, uri, expiration) => {
  const query = qs.stringify({
    type,
    uri,
    client: 'command',
    expiration,
  });

  return client({
    method: 'GET',
    path: `/signedUrl?${query}`,
  });
};

export default {
  getSignedUrl(type, uri, expiration) {
    return getSignedUrl(type, uri, expiration)
      .then((response) => {
        return response.entity.signedUrl;
      })
      .catch((err) => {
        console.error('Failed to get signed URL: ', err);
      });
  },
};
